var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 19,
    viewBox: "0 0 11 19",
    width: 11,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.6915253 36.1767611c-.2382403-.2356815-.6195249-.2356815-.8577652 0l-7.6586184 7.7294328c-.2335223.2404432-.2335223.6252533 0 .8656965l7.6586184 7.7294328c.2439241.1846347.58525.1601531.8008505-.0574409.2156005-.2175941.2398578-.562076.0569147-.8082556l-7.2297357-7.2965845 7.2297357-7.2965846c.2335223-.2404432.2335223-.6252533 0-.8656965z",
    fill: "#E3215F",
    stroke: "#E3215F",
    transform: "translate(-22 -35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/caret_left.08f56083775f0fda7a5daf53eaac29e8.svg";
export { ForwardRef as ReactComponent };